<div class="wrapper">
  <div class="banner warning-background" *ngIf="crateDetails?.crate?.cratesUnderAlert[0]?.id?.length">
    <p>PALLET BLOQUEADO</p>
    <p class="description">
      Pallet bloqueado por {{userThatBlockedPallet?.firstName + ' ' + userThatBlockedPallet?.lastName}} na data de {{formatTimestamp(crateDetails.crate.cratesUnderAlert[0]?.updatedAt)}}. 
    </p>
  </div>
  <div class="banner warning-background" *ngIf="checkIfPalletIsInSeparation()">
    <p>PALLET EM SEPARAÇÃO</p>
    <p class="description">
      Pallet reservado para ordem de saída
    </p>
  </div>
  <app-product-image-display *ngIf="showProductImage" [url]="currentProductImageUrl" (click)="displayClicked()"></app-product-image-display>
  <div class="upper-content">
    <div class="first-column">
      <app-info-oc-or-nfe label="Tag RFID" [value]="crateDetails.crate.tagRfid"
        *ngIf="crateDetails.crate.type !== CrateTypeEnum.REMAINS">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Tag RFID" [value]="'N/A'"
        *ngIf="isExit && crateDetails.crate.type === CrateTypeEnum.REMAINS">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Estado (crateState)" [value]="translateState(crateDetails.crate.state)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Posição" [value]="getPosition(crateDetails.position)"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe *ngIf="crateDetails.inOrderNumber" label="Documento" [value]="crateDetails.inOrderNumber"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Tipo" [value]="getCrateType(crateDetails.crate.type)" *ngIf="isExit"></app-info-oc-or-nfe>
    </div>
    <div class="second-column">
      <app-info-oc-or-nfe label="X" [value]="crateDetails.crate.x"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Y" [value]="crateDetails.crate.y"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Z" [value]="crateDetails.crate.z"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Nível" [value]="level"></app-info-oc-or-nfe>
    </div>
    <div class="third-column">
      <button *ngIf="!isExit"
        mat-raised-button (click)="relocateClick()" [disabled]="cantRelocate(sendTaskTypesEnum.RELOCATE_POSITION, userRole)">
        Realocar
      </button>
      <button mat-raised-button (click)="openInventorySidenav(crateDetails.crate)"
        [disabled]="fromPendingTask || isExit && crateDetails.crate.type === CrateTypeEnum.REMAINS"
        [matTooltip]="crateDetails.crate.type === CrateTypeEnum.REMAINS ? 'Pallets fracionados não podem ser inventariados.' : null"
        matTooltipClass="line-break-tooltip">
        Inventariar
      </button>
      <button mat-raised-button *ngIf="!crateDetails?.crate?.cratesUnderAlert[0]?.id?.length"
        (click)="setPalletUnderAlert(crateDetails.crate.id)" class="block-button"
        [disabled]="!canBlockPallet()"
        [matTooltip]="crateDetails.crate.type === CrateTypeEnum.REMAINS ? 'Pallets fracionados não podem ser bloqueados.' : null"
        matTooltipClass="line-break-tooltip">
        Bloquear
      </button>
      <button mat-raised-button *ngIf="crateDetails?.crate?.cratesUnderAlert[0]?.id?.length"
        (click)="unsetPalletUnderAlert(crateDetails.crate.id)" class="block-button"
        [disabled]="!canUnblockPallet()">
        Desbloquear
      </button>
    </div>
  </div>
  <div class="second-reader-container">
    <h3>Detalhes dos produtos</h3>
    <app-display-mode-control (displayModeChange)="onDisplayModeChange($event)" [initialValue]="displayMode"></app-display-mode-control>
  </div>
  <div class="lower-content">
    <div *ngIf="displayMode === 'list'" class="list-container">
    <app-product-details *ngFor="let product of skuGroups" [product]="product" (click)="productClicked($event)"></app-product-details>
    </div>
    <div *ngIf="displayMode === 'table'" class="table-container">
    <table mat-table [dataSource]="skuGroups" class="table">
      <ng-container matColumnDef="name">
        <th mat-header-cell class="header" *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="packSize">
        <th mat-header-cell class="header" *matHeaderCellDef>Tamanho do Pacote</th>
        <td mat-cell *matCellDef="let element">{{element.packSize | number:'1.0-0':'pt-BR'}}</td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
        <td mat-cell *matCellDef="let element">{{element.quantity | number:'1.0-0':'pt-BR'}}
      </ng-container>

      <ng-container matColumnDef="sku">
        <th mat-header-cell class="header" *matHeaderCellDef>Código do Item</th>
        <td mat-cell *matCellDef="let element">{{element.sku}}</td>
      </ng-container>

      <tr mat-header-row class="header-container" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="item-container" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>

    <div *ngIf="!skuGroups.length" class="no-item">
      Não existem produtos neste pallet
    </div>
  </div>
</div>
